import { gql } from '@apollo/client';

export const CONTACT_FIELDS = gql`
  fragment ContactFields on PlayerContact {
    _id
    name
    phone
    email
    sendSMS
    sendEmail
    height
    sportInvolvement
    relationship
  }
`;

// Reachability is the backend's call, made by the same rules every send applies.
export const GET_PLAYER_CONTACT_REACH = gql`
  query GetPlayerContactReach($_id: ID!) {
    playerAssessment(_id: $_id) {
      _id
      contactReach
    }
  }
`;

// The duplicate rule has one implementation and it is the backend's. Every
// contact form asks this rather than comparing credentials for itself.
export const CONTACT_DUPLICATES = gql`
  query ContactDuplicates($candidate: ContactCandidateInput!, $existing: [ContactCandidateInput!]!) {
    contactDuplicates(candidate: $candidate, existing: $existing) {
      field
      contactName
    }
  }
`;

export const CREATE_PLAYER_CONTACT = gql`
  mutation CreatePlayerContact($data: CreatePlayerContactInput!, $playerAssessmentId: ID) {
    createPlayerContact(data: $data, playerAssessmentId: $playerAssessmentId) {
      contact {
        ...ContactFields
      }
      wasUpdated
      status
    }
  }

  ${CONTACT_FIELDS}
`;

export const REMOVE_PLAYER_CONTACT = gql`
  mutation RemovePlayerContact($_id: ID!, $playerAssessmentId: ID) {
    removePlayerContact(_id: $_id, playerAssessmentId: $playerAssessmentId) {
      _id
    }
  }
`;

export const UPDATE_PLAYER_CONTACT = gql`
  mutation UpdatePlayerContact($_id: ID!, $data: UpdatePlayerContactInput!, $playerAssessmentId: ID) {
    updatePlayerContact(_id: $_id, data: $data, playerAssessmentId: $playerAssessmentId) {
      ...ContactFields
    }
  }

  ${CONTACT_FIELDS}
`;
